<template>
  <div class="prescription-reward-details">
    <div class="page_title flex between">
      <span>医生奖励统计-医生开方奖励详情</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <!-- 搜索条件 -->
        <div class="prescription-reward-details-search">
          <el-form
            ref="prescriptionRewardDetailsFormRef"
            :inline="true"
            :model="prescriptionRewardDetailsForm"
            class="demo-form-inline"
          >
            <el-form-item label="">
              <el-select
                v-model="prescriptionRewardDetailsForm.type"
                style="width: 100px"
                size="small"
                @change="changeType"
              >
                <el-option label="日报" value="1" />
                <el-option label="月报" value="2" />
              </el-select>
            </el-form-item>

            <el-form-item label="时间">
              <el-date-picker
                v-model="prescriptionRewardDetailsForm.date"
                clearable
                :type="
                  prescriptionRewardDetailsForm.type == 1
                    ? 'daterange'
                    : 'monthrange'
                "
                :value-format="
                  prescriptionRewardDetailsForm.type == 1
                    ? 'yyyy-MM-dd'
                    : 'yyyy-MM'
                "
                :format="
                  prescriptionRewardDetailsForm.type == 1
                    ? 'yyyy-MM-dd'
                    : 'yyyy-MM'
                "
                unlink-panels
                range-separator="——"
                end-placeholder="结束日期"
                start-placeholder="开始日期"
                size="small"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item label="医生姓名">
              <el-input
                v-model="prescriptionRewardDetailsForm.doctor_name"
                clearable
                style="width: 160px"
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item label="医生手机号">
              <el-input
                v-model="prescriptionRewardDetailsForm.doctor_phone"
                clearable
                size="small"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="small" @click="searchBtn">
                查 询<i class="el-icon-search el-icon--right" />
              </el-button>

              <!-- 导出 -->
              <el-button
                type="primary"
                size="small"
                @click="derive"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1773') : false
                "
              >
                导出<i class="el-icon-download el-icon--right" />
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="prescription-reward-details-table">
          <el-table
            v-loading="tableLoading"
            :header-cell-style="{ background: '#F5F5F5' }"
            :data="prescriptionRewardDetailsData"
            style="width: 100%"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :fixed="item.fixed"
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'doctor_info'">
                  <div>
                    {{ scope.row.doctor_name }}
                  </div>
                  <div>{{ scope.row.doctor_phone }}</div>
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import dayjs from "dayjs";
import marketing from "@/api/marketing";
export default {
  components: {
    Pagination,
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      moduleName: 1,
      prescriptionRewardDetailsForm: {
        type: "1",
        doctor_name: "",
        doctor_phone: "",
        date: [],
      },
      total: 100,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      tableHeader: [
        {
          label: "医生信息",
          prop: "doctor_info",
          width: "120",
          fixed: "left",
        },
        {
          label: "开方新用户数",
          prop: "new_user_count",
          width: "auto",
          fixed: false,
        },
        {
          label: "激活老用户数",
          prop: "old_user_count",
          width: "auto",
          fixed: false,
        },
        {
          label: "关联处方订单总金额",
          prop: "order_money",
          width: "auto",
          fixed: false,
        },

        {
          label: "关联处方药品总金额",
          prop: "drug_money",
          width: "auto",
          fixed: false,
        },
        {
          label: "关联处方医生收益",
          prop: "doctor_reward",
          width: "auto",
          fixed: false,
        },
        {
          label: "开方奖励总计",
          prop: "total_reward",
          width: "auto",
          fixed: false,
        },
        {
          label: "实际结算金额",
          prop: "money",
          width: "auto",
          fixed: false,
        },
      ],
      prescriptionRewardDetailsData: [],
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.prescriptionRewardDetailsForm = Object.assign(
      {},
      this.prescriptionRewardDetailsForm,
      this.$route.query
    );
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      let params = Object.assign(
        {},
        this.pagination,
        this.prescriptionRewardDetailsForm
      );
      params = _.omit(params, ["date"]);
      let times = this.prescriptionRewardDetailsForm.date;
      params["time_start"] = times ? times[0] : "";
      params["time_end"] = times ? times[1] : "";

      marketing.getDoctorPrescriptionRewardDoctorList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.total = data.total;
          this.prescriptionRewardDetailsData = data.list;
          this.tableLoading = false;
        }
      });
    },
    // 切换月/日
    changeType() {
      this.searchBtn();
    },
    // 查询
    searchBtn() {
      this.getList();
    },
    // 导出
    derive() {
      const loading = this.$loading();
      let params = Object.assign(
        {},
        this.pagination,
        this.prescriptionRewardDetailsForm
      );
      params = _.omit(params, ["date"]);
      let times = this.prescriptionRewardDetailsForm.date;
      params["time_start"] = times ? times[0] : "";
      params["time_end"] = times ? times[1] : "";
      marketing
        .exportDoctorPrescriptionRewardDoctorList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 查看详情
    toDetail(row) {
      let { doctor_id, doctor_name } = row;
      this.$router.push({
        path: "/home/marketing/detailsIndex",
        query: {
          doctor_id,
          doctor_name,
        },
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 10px 20px;
}
.prescription-reward-details {
  .prescription-reward-details-search {
    display: flex;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .prescription-reward-details-table {
    border: 1px solid #c9cdd6;
    // .el-table {
    // min-height: 476px;
    // }
  }
}
</style>
